<template>
	<b-form-group :label="label">
		<b-form-select
			:disabled="disabled"
			size="sm"
			:value="value"
			@input="$emit('input', $event)"
		>
			<b-form-select-option v-for="(item, i) in 100" :value="i" :key="i">{{
				i
			}}</b-form-select-option>
		</b-form-select>
	</b-form-group>
</template>
<script>
export default {
	props: {
		disabled: Boolean,
		value: Number,
		label: String
	}
};
</script>

